import styles from '../DavidPifView.module.css'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { Text } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'

const imgImage02 = '/v1760542873/theatrical/david/david-sling-img-01.webp'
const imgInspireGen = '/v1760914561/theatrical/david/dirt-texture-on-white-01'

export function SuperheroesSection() {
  const { t } = useTranslate('pif')
  return (
    <section className={classNames('relative w-full', styles['section-lg'])} data-name="superheros">
      <div className="absolute inset-0 bg-[#faf0e7]" />
      <Image
        alt=""
        className="object-cover opacity-[0.55] mix-blend-color-burn"
        src={imgInspireGen}
        fill
        sizes="100vw"
        loading="lazy"
      />

      <div
        className="relative mx-auto flex w-full max-w-[1440px] shrink-0 flex-col content-stretch items-center gap-[40px] text-clip lg:flex-row lg:gap-[64px]"
        data-name="container-50-flip"
      >
        <div
          className={classNames(
            'relative mx-auto w-full grow-1 overflow-hidden rounded-3xl',
            styles['david-image-aspect-ratio'],
          )}
        >
          <Image loading="lazy" alt="David with his lamb" src={imgImage02} fill className="object-cover" />
        </div>

        <div className="flex w-full flex-row items-center">
          <div className="relative h-full w-full">
            <div className="flex size-full flex-col justify-center">
              <div className="relative box-border flex size-full flex-col content-stretch items-start justify-center gap-[32px] p-0 md:gap-[40px]">
                <div className="relative flex w-full flex-col content-stretch items-start gap-[12px] not-italic">
                  <p className="font-angel-royal relative w-full text-5xl lowercase not-italic leading-[2.5rem] text-[#141447] md:text-[3.5rem] md:leading-[3rem]">
                    {t('davidSuperheroesTitle', "In a World of Superheroes, We're Telling the Story of a Real Hero")}
                  </p>
                  <Text weight="medium" className="photon-paragraph-md md:photon-paragraph-lg">
                    {t(
                      'davidSuperheroesDescription',
                      "Kids are flooded with stories of capes and gadgets. DAVID sparks their imagination with courage, faith, and the truth that with God, anything is possible. Imagine Halloween with slings and tunics instead of masks and capes—that's the power of a story told right.",
                    )}
                  </Text>
                </div>
                <DavidButton variant="dark" openPifOverlay className="w-full md:mr-auto md:w-auto">
                  {t('payItForward', 'Pay it Forward')}
                </DavidButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
